/**
 * Feature flags for ActivitiesCore.
 *
 * ENABLE_EVENT_BOOKING_UI – when false the booking/sign-up UI is hidden
 * but all backend logic (RPC, mail, RLS) stays intact so it can be
 * re-enabled later.
 *
 * ENABLE_RECURRING_UI – when false the recurring-event toggle/inputs are
 * hidden in the wizard. The underlying fields (is_recurring, recurrence_rule)
 * stay intact in the data model.
 */
export const ENABLE_EVENT_BOOKING_UI = false;
export const ENABLE_RECURRING_UI = false;
